var e = {
	id: "launch-week-2026-october",
	shopOrigin: "https://gridnookshop.com",
	apiVersion: "2026-10",
	automaticDiscountTitle: "Launch Week - 20% Off",
	expectedPercentage: 20,
	displayStartsAt: "2026-10-04T14:29:00+03:00",
	endsAt: "2026-10-31T23:59:00+02:00",
	timezone: "Europe/Bucharest",
	dateSource: "Owner-confirmed Shopify discount settings on 2026-10-28; Admin read_discounts unavailable.",
	buyerRulesVerified: !0,
	customers: "all",
	minimumRequirement: null,
	marketRestriction: null,
	pointOfSale: !1,
	combinesWith: {
		productDiscounts: !1,
		orderDiscounts: !1,
		shippingDiscounts: !1
	},
	eligibleProductIds: [
		"10406129434953",
		"10436735926601",
		"10475975803209"
	],
	quoteMaxAgeMs: 3e5
};
//#endregion
//#region shared/commerce/promotion-pricing.mjs
function t(e, t, n) {
	let r = Number(e), i = n?.currencyCode === t ? Number(n.amount) : 0;
	return {
		regular: r,
		amount: r,
		currency: t,
		discounted: !1,
		compareAt: Number.isFinite(i) && i > r ? i : null
	};
}
function n(e, t = Date.now()) {
	let n = e.discounted && r(t), i = n ? e.amount : e.regular, a = e.compareAt > i ? e.compareAt : n ? e.regular : null;
	return {
		amount: i,
		original: a,
		automatic: n,
		savings: a ? a - i : 0
	};
}
var r = (t = Date.now(), n = e) => Number.isFinite(Date.parse(n.displayStartsAt)) && Number.isFinite(Date.parse(n.endsAt)) && t >= Date.parse(n.displayStartsAt) && t < Date.parse(n.endsAt);
function i(t, { variantId: n, productId: i, currency: a, now: o = Date.now(), knownCustomer: s = !1, config: c = e } = {}) {
	let l = t?.data?.cartCreate?.cart;
	if (t?.errors?.length || t?.data?.cartCreate?.userErrors?.length || !l) return null;
	let u = l.lines?.nodes || [];
	if (u.length !== 1 || u[0].quantity !== 1) return null;
	let d = u[0];
	if (d.merchandise?.id?.split("/").at(-1) !== String(n)) return null;
	let f = Number(d.cost?.subtotalAmount?.amount), p = Number(d.cost?.totalAmount?.amount), m = d.cost?.totalAmount?.currencyCode;
	if (!Number.isFinite(f) || !Number.isFinite(p) || f <= 0 || p < 0 || !m || a && a !== m) return null;
	let h = {
		regular: f,
		amount: f,
		currency: m,
		discounted: !1,
		expiresAt: null
	};
	if (!r(o, c) || !c.eligibleProductIds.includes(String(i)) || s && !c.buyerRulesVerified) return h;
	let g = d.discountAllocations || [], _ = g.find((e) => e.__typename === "CartAutomaticDiscountAllocation" && e.title === c.automaticDiscountTitle);
	if (!_ || g.length !== 1 || l.discountAllocations?.length || !(p < f)) return h;
	let v = c.expectedPercentage, y = 10 ** new Intl.NumberFormat("en", {
		style: "currency",
		currency: m
	}).resolvedOptions().maximumFractionDigits, b = Math.round((f - Math.round(f * v / 100 * y) / y) * y) / y;
	return Math.abs(p - b) > .5 / y || _.discountedAmount.currencyCode !== m ? h : {
		regular: f,
		amount: p,
		currency: m,
		discounted: !0,
		percentage: v,
		expiresAt: c.endsAt
	};
}
var a = /* @__PURE__ */ new Map();
async function o(t, n, r = fetch) {
	let i = await r(`${e.shopOrigin}/api/${e.apiVersion}/graphql.json`, {
		method: "POST",
		credentials: "omit",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			query: t,
			variables: n
		}),
		signal: AbortSignal.timeout(12e3)
	});
	if (!i.ok) throw Error("Shopify pricing unavailable");
	let a = await i.json();
	if (a.errors?.length) throw Error("Shopify pricing unavailable");
	return a;
}
var s = "mutation OfferQuote($input: CartInput!) {\n  cartCreate(input: $input) { userErrors { message } cart {\n    discountAllocations { __typename }\n    lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } }\n      cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } }\n      discountAllocations { __typename discountedAmount { amount currencyCode }\n        ... on CartAutomaticDiscountAllocation { title } }\n    } }\n  } }\n}";
async function c({ variantId: t, productId: n, country: r, currency: c, knownCustomer: l = !1 }, { fetchImpl: u = fetch, now: d = Date.now() } = {}) {
	if (!/^[A-Z]{2}$/.test(r || "") || !/^\d+$/.test(String(t))) return null;
	let f = [
		t,
		n,
		r,
		c,
		l
	].join(":"), p = a.get(f);
	if (p && d - p.at < e.quoteMaxAgeMs) return p.promise;
	let m = o(s, { input: {
		buyerIdentity: { countryCode: r },
		lines: [{
			merchandiseId: `gid://shopify/ProductVariant/${t}`,
			quantity: 1
		}]
	} }, u).then((e) => i(e, {
		variantId: t,
		productId: n,
		currency: c,
		knownCustomer: l,
		now: Date.now()
	})).catch(() => null);
	return a.set(f, {
		at: d,
		promise: m
	}), m;
}
async function l(e, t, n = fetch) {
	if (!/^\d+$/.test(String(e)) || !/^[A-Z]{2}$/.test(t || "")) return null;
	try {
		return (await o("query PackagePrices($id: ID!, $country: CountryCode!) @inContext(country: $country) {\n      product(id: $id) { id variants(first: 20) { nodes { id title availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } } } }\n    }", {
			id: `gid://shopify/Product/${e}`,
			country: t
		}, n)).data?.product || null;
	} catch {
		return null;
	}
}
function u(e, t, n = "en-US") {
	return new Intl.NumberFormat(n, {
		style: "currency",
		currency: t
	}).format(e);
}
//#endregion
//#region shared/commerce/promotion-ui.mjs
var d = ".gn-offer-price{display:inline-flex;flex-wrap:wrap;align-items:baseline;justify-content:inherit;gap:.35em .55em;max-width:100%;line-height:1.5}.gn-offer-price strong{font-weight:750;font-size:1.08em;white-space:nowrap}.gn-offer-price s{font-size:.78em;font-weight:400;color:#6d6262;white-space:nowrap}.gn-offer-badge{font-size:.66em;font-weight:650;white-space:nowrap;padding:.12em .55em;border-radius:99px;color:#702126;background:#f6e6e3}.gn-price-note{font-size:.78rem;color:#6d6262;margin:.6rem 0;line-height:1.5}.product__price .gn-price-note{display:block;flex-basis:100%}.gn-package-summary{margin-top:1rem;display:flex;flex-wrap:wrap;gap:.5rem;align-items:baseline}.gn-price-summary-label{font-weight:600}.cz-package-price.gn-offer-price{justify-content:center}@media(max-width:600px){.gn-offer-price{gap:.25em .45em}.cz-packages{grid-template-columns:1fr!important}.cz-package{display:grid;grid-template-columns:minmax(0,1fr) auto;column-gap:.6rem;align-items:center;text-align:left}.cz-package-name{grid-column:1;grid-row:1}.cz-package-price.gn-offer-price{grid-column:2;grid-row:1 / span 2;justify-content:flex-end;font-size:1rem}.cz-package-choose{grid-column:1;grid-row:2}}", f = /* @__PURE__ */ new WeakMap(), p = ".cz-package-price.gn-price-unavailable{font-size:.8rem;white-space:normal;line-height:1.4}@media(max-width:600px){.cz-package-price.gn-price-unavailable{grid-column:1 / -1;grid-row:3;text-align:left;margin-top:.4rem}}", m, h, g = !1, _ = 0, v = (e, t, n = "") => {
	let r = document.createElement(e);
	return r.textContent = t, r.className = n, r;
};
function y() {
	let e = document.getElementById("gridnook-pricing-context");
	if (e) try {
		return JSON.parse(e.textContent);
	} catch {
		return {};
	}
	let t = new URLSearchParams(location.search);
	return {
		country: t.get("gn_country"),
		currency: t.get("gn_currency"),
		knownCustomer: t.get("gn_buyer") !== "guest",
		productId: t.get("product") || t.get("product_id"),
		competingDiscount: t.get("gn_other_discount") === "1",
		locale: document.documentElement.lang || "en-US",
		text: {
			badge: "20% off",
			included: "Displayed offer price includes 20% off. Taxes, if applicable, are calculated in Shopify.",
			regular: "Regular price",
			offer: "Offer price",
			taxNote: "Taxes, if applicable, are calculated in Shopify.",
			unavailable: "Choose your market in the shop to see the current price.",
			summary: "Selected package"
		}
	};
}
function b(e, t, r = "") {
	if (!t) return;
	let { amount: i, original: a, automatic: o, savings: s } = n(t), c = a !== null, l = JSON.stringify([
		i,
		a,
		t.currency,
		c,
		r
	]);
	if (f.get(e) === l) return;
	f.set(e, l), e.classList.add("gn-offer-price"), e.classList.remove("gn-price-unavailable");
	let d = [];
	r && d.push(v("span", r));
	let p = v("strong", u(i, t.currency, h.locale));
	if (p.setAttribute("aria-label", `${c ? h.text.offer : h.text.regular}: ${p.textContent}`), d.push(p), c) {
		let e = v("s", u(a, t.currency, h.locale));
		e.setAttribute("aria-label", `${h.text.regular}: ${e.textContent}`);
		let n = o && !t.compareAt ? h.text.badge : `Save ${u(s, t.currency, h.locale)}`;
		d.push(e, v("span", n, "gn-offer-badge"));
	}
	e.replaceChildren(...d), e.dataset.gnDiscounted = String(c), e.dataset.gnAutomatic = String(!!o);
}
async function x(n) {
	let i;
	try {
		i = JSON.parse(n.dataset.gnCandidates);
	} catch {
		return;
	}
	if (!Array.isArray(i) || !i.length) return;
	let a = await Promise.all(i.map(async (n) => {
		let i = t(n.amount, h.currency, {
			amount: n.compareAt,
			currencyCode: h.currency
		});
		if (!r() || g || !e.eligibleProductIds.includes(String(n.productId))) return i;
		let a = await c({
			...n,
			...h
		});
		return a && Math.abs(a.regular - i.regular) < 1e-5 ? {
			...a,
			compareAt: i.compareAt
		} : i;
	}));
	if (a.sort((e, t) => (e.discounted && r() ? e.amount : e.regular) - (t.discounted && r() ? t.amount : t.regular)), n.isConnected) {
		b(n, a[0], n.dataset.gnLabel || "");
		let e = n.closest(".product__price");
		if (e) {
			let t = e.querySelector(".gn-price-note");
			t || (t = v("span", "", "gn-price-note"), e.append(t));
			let n = a[0].discounted && r() ? h.text.included : h.text.taxNote;
			t.textContent !== n && (t.textContent = n);
		}
	}
}
async function S() {
	let n = [...document.querySelectorAll(".cz-package[role=\"radio\"]")];
	if (!n.length) return;
	if (!h.country) {
		for (let e of n) {
			let t = e.querySelector(".cz-package-price");
			t && !f.has(t) && (f.set(t, "unknown"), t.classList.add("gn-price-unavailable"), t.textContent = h.text.unavailable);
		}
		return;
	}
	m ||= l(h.productId, h.country);
	let i = await m;
	if (!i) {
		for (let e of n) {
			let t = e.querySelector(".cz-package-price");
			t && f.get(t) !== "unavailable" && (f.set(t, "unavailable"), t.classList.add("gn-price-unavailable"), t.textContent = "Current price is available in Shopify.");
		}
		m = null;
		return;
	}
	let a = n.find((e) => e.getAttribute("aria-checked") === "true"), o;
	await Promise.all(n.map(async (n) => {
		let s = n.querySelector(".cz-package-name")?.textContent?.trim(), l = i.variants.nodes.find((e) => e.title === s && e.availableForSale), u = n.querySelector(".cz-package-price");
		if (!l || !u) return;
		let d = t(l.price.amount, l.price.currencyCode, [
			"10406129434953",
			"10436735926601",
			"10475975803209"
		].includes(String(h.productId)) ? l.compareAtPrice : null), f = d;
		if (r() && !g && e.eligibleProductIds.includes(String(h.productId))) {
			let e = await c({
				variantId: l.id.split("/").at(-1),
				...h,
				currency: l.price.currencyCode
			});
			e && Math.abs(e.regular - d.regular) < 1e-5 && (f = {
				...e,
				compareAt: d.compareAt
			});
		}
		u.isConnected && b(u, f), n === a && (o = f);
	}));
	let s = n[0].closest(".cz-panel");
	if (!s || !o || !a?.isConnected) return;
	let u = s.querySelector(".gn-package-summary");
	u || (u = v("div", "", "gn-package-summary"), u.append(v("span", h.text.summary, "gn-price-summary-label"), v("span", "", "gn-summary-price")), s.append(u));
	let d = `${h.text.summary || "Selected package"}: ${a.querySelector(".cz-package-name")?.textContent || ""}`;
	u.querySelector(".gn-price-summary-label").textContent !== d && (u.querySelector(".gn-price-summary-label").textContent = d), b(u.querySelector(".gn-summary-price"), o);
	let p = s.querySelector(".gn-price-note");
	p || (p = v("p", "", "gn-price-note"), s.append(p));
	let _ = o.discounted && r() ? h.text.included : h.text.taxNote;
	p.textContent !== _ && (p.textContent = _);
}
var C = !1, w = !1, T = !1;
async function E() {
	if (w) {
		T = !0;
		return;
	}
	w = !0;
	try {
		if (location.origin === e.shopOrigin && Date.now() - _ >= e.quoteMaxAgeMs) {
			_ = Date.now();
			try {
				let t = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
					credentials: "same-origin",
					cache: "no-store"
				});
				if (!t.ok) throw Error("Cart context unavailable");
				let n = await t.json();
				g = [...n.cart_level_discount_applications || [], ...(n.items || []).flatMap((e) => (e.line_level_discount_allocations || []).map((e) => e.discount_application))].some((t) => t && (t.type !== "automatic" || t.title !== e.automaticDiscountTitle)) || (n.discount_codes || []).some((e) => e.applicable !== !1);
			} catch {
				g = !0;
			}
		}
		await Promise.all([...document.querySelectorAll("[data-gn-candidates]")].map(x)), await S();
		for (let e of document.querySelectorAll("[data-gn-promotion-copy]")) {
			let t = r() && document.querySelector("[data-gn-automatic=\"true\"]") ? e.dataset.gnPromotionCopy : e.dataset.gnRegularCopy;
			t && e.textContent !== t && (e.textContent = t);
		}
	} finally {
		w = !1, T && (T = !1, D());
	}
}
function D() {
	C || (C = !0, setTimeout(() => {
		C = !1, E().catch(() => {});
	}, 80));
}
function O() {
	if (document.getElementById("gn-offer-styles")) return;
	h = y(), g = h.competingDiscount === !0, document.addEventListener("click", (e) => {
		let t = e.target.closest?.("a[data-gridnook-personalize]");
		if (t && g) {
			let e = new URL(t.href);
			e.searchParams.set("gn_other_discount", "1"), t.href = e.href;
		}
	}, !0);
	let t = v("style", d + p);
	t.id = "gn-offer-styles", document.head.append(t), new MutationObserver(D).observe(document.body, {
		childList: !0,
		subtree: !0,
		attributes: !0,
		attributeFilter: ["aria-checked"]
	}), document.addEventListener("visibilitychange", () => {
		document.hidden || D();
	}), setInterval(() => {
		document.hidden || D();
	}, e.quoteMaxAgeMs);
	let n = Date.parse(e.endsAt) - Date.now();
	n > 0 && n < 2147483647 && setTimeout(D, n + 10), D();
}
typeof document < "u" && (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", O, { once: !0 }) : O());
//#endregion
export { O as startPromotionUI };
